import { useCallback, useState } from 'react';
import ToastService from '../../../services/ToastService';
import GameAPI from '../GameAPI';
import { gatheringErrorMessage } from './gathering';

export default function useGatheringActions({
  refreshResourceNodes,
  refreshUser,
}) {
  const [cancelling, setCancelling] = useState(false);

  const cancelGathering = useCallback(async () => {
    if (cancelling) return null;
    setCancelling(true);
    try {
      const result = await GameAPI.cancelGathering();
      await Promise.all([
        refreshResourceNodes(),
        refreshUser(),
      ]);
      ToastService.push(
        result?.cancelled
          ? 'Gathering cancelled.'
          : 'Gathering has already ended.',
        'info',
      );
      return result;
    } catch (error) {
      await Promise.allSettled([
        refreshResourceNodes(),
        refreshUser(),
      ]);
      ToastService.push(gatheringErrorMessage(
        error,
        'Gathering could not be cancelled. Your current state was refreshed.',
      ), 'error');
      return null;
    } finally {
      setCancelling(false);
    }
  }, [
    cancelling,
    refreshResourceNodes,
    refreshUser,
  ]);

  return {
    cancelGathering,
    gatheringCancelBusy: cancelling,
  };
}
